// extracted by mini-css-extract-plugin
export var typingIndicator = "_oz-0";